import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, PlayIcon, TrophyIcon } from 'lucide-react';
const steps = [{
  title: 'Descarga el Protocolo',
  desc: 'Obtén acceso inmediato al manual maestro en PDF.',
  icon: DownloadIcon
}, {
  title: 'Inicia la Purga',
  desc: 'Sigue las instrucciones de la Fase 1 desde el minuto uno.',
  icon: PlayIcon
}, {
  title: 'Conviértete en Leyenda',
  desc: 'En 21 días, el hombre débil que eras habrá muerto.',
  icon: TrophyIcon
}];
export function HowItWorks() {
  return <section className="py-12 sm:py-16 lg:py-24 relative bg-dark-surface border-y border-dark-border" data-id="element-71">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} className="text-center mb-10 sm:mb-16" data-id="element-73">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-74">
            CÓMO FUNCIONA
          </h2>
          <div className="w-24 h-[2px] bg-gold mx-auto" data-id="element-75" />
        </motion.div>

        {/* Mobile layout: simple vertical stack */}
        <div className="flex flex-col gap-8 sm:hidden" data-id="element-76">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.2
        }} className="flex items-start gap-4" data-id="element-77">
              <div className="flex flex-col items-center shrink-0" data-id="element-78">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-dark-bg border-2 border-gold text-gold shadow-[0_0_15px_rgba(200,162,60,0.2)]" data-id="element-79">
                  <step.icon className="w-5 h-5" data-id="element-80" />
                </div>
                {index < steps.length - 1 && <div className="w-[2px] h-8 bg-dark-border mt-2" data-id="element-81" />}
              </div>
              <div className="bg-dark-card border border-dark-border p-4 rounded-sm flex-1" data-id="element-82">
                <h3 className="text-lg font-bold text-white mb-1 font-cinzel" data-id="element-83">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-400" data-id="element-84">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Tablet/Desktop layout: alternating timeline */}
        <div className="hidden sm:block relative" data-id="element-85">
          {/* Vertical connecting line */}
          <div className="absolute left-1/2 top-0 bottom-0 w-[2px] bg-dark-border -translate-x-1/2" data-id="element-86" />

          <div className="space-y-12 relative z-10" data-id="element-87">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            delay: index * 0.2
          }} className={`flex items-center gap-8 lg:gap-12 ${index % 2 === 0 ? 'flex-row-reverse' : ''}`} data-id="element-88">
                {/* Content */}
                <div className={`flex-1 ${index % 2 === 0 ? 'text-left' : 'text-right'}`} data-id="element-89">
                  <div className="bg-dark-card border border-dark-border p-5 sm:p-6 rounded-sm hover:border-gold/30 transition-colors" data-id="element-90">
                    <h3 className="text-lg sm:text-xl font-bold text-white mb-2 font-cinzel" data-id="element-91">
                      {step.title}
                    </h3>
                    <p className="text-sm sm:text-base text-gray-400" data-id="element-92">
                      {step.desc}
                    </p>
                  </div>
                </div>

                {/* Center Icon */}
                <div className="flex items-center justify-center w-14 h-14 lg:w-16 lg:h-16 rounded-full bg-dark-bg border-2 border-gold text-gold shrink-0 z-10 shadow-[0_0_15px_rgba(200,162,60,0.2)]" data-id="element-93">
                  <step.icon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-94" />
                </div>

                {/* Empty space for alternating layout */}
                <div className="flex-1" data-id="element-95" />
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}